// extracted by mini-css-extract-plugin
module.exports = {"form":"index_form_1popL","formTab":"index_formTab_3CP_z","info":"index_info_2GRyA","bg":"index_bg_2TIuB","row":"index_row_M2cQl"};